// export const juniperUrl = "https://travcojuniperapi.titegypt.org";
export const juniperUrl = "https://apijuniper.travco.com";
